import { useCallback, useSyncExternalStore } from 'react'

import type { UseEmblaCarouselType } from 'embla-carousel-react'

const serverSnapshot = () => 0

/** 선택 인덱스와 양쪽 이동 가능 상태를 같은 Embla 구독으로 읽는다. */
export function useCarouselState(
  api: UseEmblaCarouselType[1],
  trackSelection: boolean
) {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!api) return () => {}
      api.on('select', onChange)
      api.on('reInit', onChange)
      return () => {
        api.off('select', onChange)
        api.off('reInit', onChange)
      }
    },
    [api]
  )
  // 하위 두 비트는 이전/다음 이동 가능 여부, 나머지는 선택 인덱스다.
  // 원시값 snapshot은 상태가 같을 때 React가 불필요한 렌더를 생략하게 한다.
  const getSnapshot = useCallback(
    () =>
      api
        ? (trackSelection ? api.selectedScrollSnap() * 4 : 0) +
          (api.canScrollPrev() ? 1 : 0) +
          (api.canScrollNext() ? 2 : 0)
        : 0,
    [api, trackSelection]
  )
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, serverSnapshot)
  return {
    current: Math.floor(snapshot / 4),
    canScrollPrev: (snapshot & 1) !== 0,
    canScrollNext: (snapshot & 2) !== 0,
  }
}
